// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .mycomponent-wider-popover {
  --width: 95%;
  --max-width: 400px;
}

ion-grid {
  border-radius: 10px;
  background: var(--ion-item-background);
  margin: 16px 0;
}
ion-grid ion-row {
  border-bottom: 1px solid var(--ion-item-border-color);
  margin: 0px 16px;
}
ion-grid ion-row:last-child {
  border-bottom: 0;
}
ion-grid h5 {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
}
ion-grid h6 {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #747889;
}
ion-grid h3 {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  margin-top: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/admin/leads/modals/filters/filters.page.scss"],"names":[],"mappings":"AAAA;EAEE,YAAA;EACA,kBAAA;AAAF;;AAGA;EACI,mBAAA;EACA,sCAAA;EACA,cAAA;AAAJ;AACI;EACI,qDAAA;EACA,gBAAA;AACR;AAEI;EACI,gBAAA;AAAR;AAGI;EACI,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AADR;AAII;EACI,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAFR;AAKI;EACI,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;AAHR","sourcesContent":["::ng-deep .mycomponent-wider-popover\n{\n  --width: 95%;\n  --max-width: 400px;\n}\n\nion-grid {\n    border-radius: 10px;\n    background: var(--ion-item-background);\n    margin: 16px 0;\n    ion-row {\n        border-bottom: 1px solid var(--ion-item-border-color);\n        margin: 0px 16px;\n    }\n\n    ion-row:last-child {\n        border-bottom: 0;\n    }\n\n    h5 {\n        font-family: 'Roboto';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 19px;\n    }\n\n    h6 {\n        font-family: 'Roboto';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 16px;\n        color: #747889;\n    }\n    \n    h3 {\n        font-family: 'Roboto';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 19px;\n        margin-top: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
